// extracted by mini-css-extract-plugin
export default {"root":"NoData_root-fSJ","icon":"NoData_icon-eEt","title":"NoData_title-iDQ"};